module.exports = __webpack_public_path__ + "img/placeholder.1c0c3479.svg";